import React from 'react';

//create fb share btn
const FbShareBtn = ({ fbShareClass, shareUrl }) => (
  <div
    className={`fb-share-button ${fbShareClass}`}
    data-href={shareUrl}
    data-layout="button_count"
    data-size="large"
  />
);

export default FbShareBtn;
